import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { SearchDataResponse } from "../../../business/core/controllers/SearchPageController";
import { SearchPageControllerImpl } from "../../../business/impl/controllers";
import { SearchPageFactoryImpl } from "../factories";

export function SearchPage() {
  const location = useLocation();
  const [isLoading, setLoading] = useState(true);
  const [searchData, setSearchData] = useState<SearchDataResponse>();

  const controller = new SearchPageControllerImpl();
  const factory = new SearchPageFactoryImpl();

  const fetchData = async () => {

    try {
      const response = await controller.onLoad(location.state.term);
      setLoading(false);
      setSearchData(response);
    } catch (error) {
      console.error("Erro na requisição:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [location]);

  return isLoading ? <Spinner animation="border" variant="primary" /> : factory.create(searchData);
}
